// extracted by mini-css-extract-plugin
export var cardHeader = "_fd-0";
export var reorderHandle = "_fd-3";
export var titleArea = "_fd-1";
export var titleAreaWithHandle = "_fd-2";